module.exports = __webpack_public_path__ + "static/iCertify Logo-318bb953fc136cca97a00ed8fc77a3a5.png";